import type {SVGProps} from 'react'
import {useId} from 'react'
const LookBuilderIcon = (props: SVGProps<SVGSVGElement>) => {
  const uid = useId().replace(/[^a-zA-Z0-9_-]/g, '')
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      width="1em"
      height="1em"
      overflow="visible"
      style={{
        display: 'block',
      }}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Outline">
        <path
          id="Intersect"
          d="M7.93655 5.44459L7.37087 4.87891C6.19929 6.05048 6.19929 7.94997 7.37087 9.12155L7.93655 8.55586C7.0774 7.69671 7.0774 6.30375 7.93655 5.44459Z"
          fill={`url(#${uid}paint0_linear_13120_20419)`}
        />
        <path
          id="Intersect_2"
          d="M11.048 5.44482L11.6137 4.87913C10.4422 3.70756 8.54267 3.70756 7.37109 4.87913L7.93678 5.44482C8.79593 4.58566 10.1889 4.58566 11.048 5.44482Z"
          fill={`url(#${uid}paint1_linear_13120_20419)`}
        />
        <path
          id="Intersect_3"
          d="M11.0478 5.44459C11.907 6.30375 11.907 7.69671 11.0478 8.55586L11.6135 9.12155C12.7851 7.94997 12.7851 6.05048 11.6135 4.87891L11.0478 5.44459Z"
          fill={`url(#${uid}paint2_linear_13120_20419)`}
        />
        <path
          id="Intersect_4"
          d="M7.93678 8.55563L7.37109 9.12132C8.54267 10.2929 10.4422 10.2929 11.6137 9.12132L11.048 8.55563C10.1889 9.41479 8.79593 9.41479 7.93678 8.55563Z"
          fill={`url(#${uid}paint3_linear_13120_20419)`}
        />
        <circle
          id="Ellipse 1101"
          cx={3}
          cy={3}
          r={2.6}
          stroke={`url(#${uid}paint4_linear_13120_20419)`}
          strokeWidth={0.8}
        />
        <circle
          id="Ellipse 1103"
          cx={3}
          cy={11}
          r={2.6}
          stroke={`url(#${uid}paint5_linear_13120_20419)`}
          strokeWidth={0.8}
        />
      </g>
      <defs>
        <linearGradient
          id={`${uid}paint0_linear_13120_20419`}
          x1={7.72487}
          y1={8.76777}
          x2={7.72487}
          y2={5.23223}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#389A97" />
          <stop offset={0.513837} stopColor="#2285CD" />
          <stop offset={1} stopColor="#93506A" />
          <stop offset={1} stopColor="#93506A" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint1_linear_13120_20419`}
          x1={11.2602}
          y1={5.23269}
          x2={7.72465}
          y2={5.23269}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E78B5" />
          <stop offset={1} stopColor="#93506A" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint2_linear_13120_20419`}
          x1={11.2599}
          y1={5.23223}
          x2={10.9064}
          y2={8.41421}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E78B5" />
          <stop offset={1} stopColor="#2285CD" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint3_linear_13120_20419`}
          x1={10.9066}
          y1={8.41396}
          x2={8.0782}
          y2={8.41396}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2285CD" />
          <stop offset={1} stopColor="#389A97" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint4_linear_13120_20419`}
          x1={0.5}
          y1={4.5}
          x2={5.5}
          y2={2.5}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DC9F1C" />
          <stop offset={1} stopColor="#E42922" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint5_linear_13120_20419`}
          x1={4.5}
          y1={13}
          x2={1.5}
          y2={9}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#58B64A" />
          <stop offset={1} stopColor="#DC9F1C" />
        </linearGradient>
      </defs>
    </svg>
  )
}
export {LookBuilderIcon}
